import { render, staticRenderFns } from "./Promocoes.vue?vue&type=template&id=223965cd&scoped=true"
import script from "./Promocoes.vue?vue&type=script&lang=js"
export * from "./Promocoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223965cd",
  null
  
)

export default component.exports